export const IDLE_DISCONNECT_GRACE_MS = 5 * 60 * 1000

export const PUSHER_ACTIVE_STATES = ['connected', 'connecting']
